<template>
  <b-card style="max-width: 300px" class="mt-4 ml-4 mb-4">
    <b-card-title title-tag="h5" class="text-dark title">
      {{ title }}
    </b-card-title>
    <b-img-lazy class="mb-2 image" :src="image" center thumbnail height="250" />
    <b-card-text class="text-muted body">{{ about }}</b-card-text>
    <a :href="link">{{ link }}</a>
  </b-card>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      Type: String,
      default: ''
    },
    link: {
      Type: String,
      default: ''
    },
    file: {
      Type: String,
      default: ''
    },
    about: {
      Type: String,
      default: ''
    }
  },
  data () {
    return {
      image: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.image = require('@/assets/thumbnails/' + this.file)
    })
  }
}
</script>

<style scoped>
.title {
  height: 60px;
}
.image {
  height: 200px;
  border: none;
}
</style>
